import { WlEventsToolbarEventTypeEnum } from './toolbar-events-broadcast-event-type.enum';

/**
 * event emitted by toolbar
 */
export class WlEventsToolbarEvent {
  public constructor(public type: WlEventsToolbarEventTypeEnum = null, public data: any = null) {}
}
